module.exports = {
      id: "speaker-usage",
      viewBox: "0 0 15 12",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#speaker",
      toString: function () {
        return this.url;
      }
    }